import { Injectable } from '@angular/core';
import {
  DEFAULT_TENANT,
  TENANTS_BY_HOST,
  TenantConfig,
} from '../config/tenant-config';
import { PortalContextService } from './portal-context.service';

@Injectable({ providedIn: 'root' })
export class TenantService {
  private _tenant: TenantConfig | null = null;

  constructor(private portalContextService: PortalContextService) {}

  private findTenantById(tenantId: string): TenantConfig | null {
    const normalizedTenantId = tenantId.trim().toLowerCase();
    if (!normalizedTenantId) {
      return null;
    }

    const matchedTenant = Object.values(TENANTS_BY_HOST).find(
      tenant => tenant.id.toLowerCase() === normalizedTenantId
    );

    return matchedTenant ?? null;
  }

  private resolveTenant(): TenantConfig {
    const tenantId = this.portalContextService.getTenantName();
    const apiBaseUrl = this.portalContextService.getApiBaseUrl();
    const matchedTenant = this.findTenantById(tenantId);

    if (matchedTenant) {
      return {
        ...matchedTenant,
        id: tenantId,
        name: tenantId,
        apiBaseUrl: apiBaseUrl || matchedTenant.apiBaseUrl,
      };
    }

    const fallbackId = tenantId || DEFAULT_TENANT.id;
    const fallbackName = tenantId || DEFAULT_TENANT.name;

    return {
      ...DEFAULT_TENANT,
      id: fallbackId,
      name: fallbackName,
      apiBaseUrl: apiBaseUrl || DEFAULT_TENANT.apiBaseUrl,
    };
  }

  get current(): TenantConfig {
    if (!this._tenant) {
      this._tenant = this.resolveTenant();
    }
    return this._tenant;
  }

  get id(): string {
    return this.current.id;
  }

  get apiBaseUrl(): string {
    return this.current.apiBaseUrl;
  }
}
